import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  es: {
    translation: {
      common: {
        loading: 'Cargando…',
        error: 'Algo salió mal',
        retry: 'Reintentar',
        cancel: 'Cancelar',
      },
      nav: {
        dashboard: 'Panel',
        organization: 'Mi organización',
        businesses: 'Mis negocios',
        services: 'Servicios y hardware',
        novedades: 'Novedades',
        billing: 'Facturación',
        credits: 'Créditos y recargas',
        statistics: 'Estadísticas',
        settings: 'Configuración',
        tickets: 'Tickets',
        community: 'Comunidad',
      },
      community: {
        badge: 'Comunidad TECOPOS',
        title: 'Resuelve tus dudas con otros negocios como el tuyo',
        description:
          'La comunidad de soporte de TECOPOS es el punto de encuentro entre negocios: pregunta, comparte soluciones y aprende de quienes ya usan el ecosistema todos los días.',
        bullet1: 'Preguntas y respuestas entre negocios, moderadas por nuestro equipo',
        bullet2: 'Soluciones verificadas y reconocimiento a quienes ayudan',
        bullet3: 'Abre tickets de soporte y dales seguimiento sin salir del portal',
        cta: 'Visitar la comunidad',
      },
      novedades: {
        badge: 'Novedades',
        tituloAviso: 'Lo nuevo en TECOPOS',
        subtituloAviso:
          'Un resumen de lo que cambió en cada producto durante las últimas semanas.',
        verDetalles: 'Ver los detalles',
        verTodo: 'Ver todo',
        entendido: 'Entendido',
        pieAviso: 'Podrás volver a leerlo en',
        tituloPagina: 'Novedades',
        subtituloPagina: 'Lo que cambió en cada producto, contado en dos líneas.',
        vacio:
          'Por ahora no hay novedades que contar. Cuando publiquemos una mejora, aparecerá aquí.',
        error:
          'No pudimos cargar las novedades. Vuelve a intentarlo en un momento.',
      },
      // Acceso a la trivia semanal de la comunidad (goal trivias 5). El texto
      // NO promete «hay una trivia nueva»: el portal no consulta la comunidad.
      trivia: {
        seccionMenu: 'Comunidad',
        menu: 'Trivia semanal',
        nuevaPestana: '(se abre en una pestaña nueva)',
        tarjetaTitulo: 'La trivia semanal de la comunidad',
        tarjetaTexto:
          'Cada lunes se publica una pregunta nueva en la comunidad. Respóndela, mira si acertaste y suma puntos.',
        tarjetaCta: 'Ir a la trivia',
      },
      releases: {
        badge: 'Actualizaciones',
        title: 'Lo nuevo en tus productos',
        seeAll: 'Ver todas',
        seeMore: 'Ver más actualizaciones',
        version: 'Versión {{version}}',
        historyTitle: 'Actualizaciones de los productos',
        historyDescription:
          'Cada mejora que llega a producción, contada en lenguaje claro: qué cambió, qué se arregló y qué puedes hacer ahora.',
        historyEmpty: 'Aún no hay notas de versión publicadas.',
        historyEmptyFiltered:
          'Aún no hay notas de versión de esta aplicación.',
        allUpdates: 'Todas las actualizaciones',
        noteNotFound:
          'No encontramos esa actualización. Aquí tienes las demás.',
        filterAll: 'Todas',
        filterAria: 'Filtrar por aplicación',
        rating: {
          groupAria: 'Valorar esta actualización',
          rateAria: 'Valorar con {{count}} de 5 estrellas',
          votes_one: '{{count}} valoración',
          votes_other: '{{count}} valoraciones',
          noVotes: 'Sin valoraciones aún',
          yourScore: 'Tu valoración: {{score}}★',
          signIn: 'Inicia sesión para valorar',
          error: 'No se pudo guardar tu valoración. Inténtalo de nuevo.',
        },
      },
      tickets: {
        title: 'Tickets de soporte',
        subtitle: 'Tickets de soporte de tu organización',
        newTicket: 'Nuevo ticket',
        empty: 'No hay tickets con esos filtros',
        searchPlaceholder: 'Buscar por título o código…',
        allStates: 'Todos los estados',
        allTypes: 'Todos los tipos',
        allBusinesses: 'Todos los negocios',
        columns: {
          code: 'Código',
          title: 'Título',
          state: 'Estado',
          type: 'Tipo',
          business: 'Negocio',
          date: 'Fecha',
        },
        detail: {
          timelineTitle: 'Actividad',
          timelineLabel: 'Cronología del ticket',
          timelineError: 'No pudimos cargar la actividad de este ticket',
          opened: 'Ticket abierto',
          loadOlder: 'Ver actividad anterior',
          stateChangedFrom: 'Estado cambiado de {{from}} a {{to}} el {{date}}',
          stateChangedTo: 'Estado cambiado a {{to}} el {{date}}',
          attachments: 'Adjuntos',
          comment: 'Comentar',
          commentPlaceholder: 'Escribe un comentario para el equipo de soporte…',
          confirmFixed: 'Confirmar corrección',
          confirmFixedQuestion:
            '¿Confirmas que la corrección de este ticket funciona? El equipo de soporte recibirá tu confirmación.',
          fixConfirmed: 'Corrección confirmada',
          automatic: 'Automático',
          you: 'Tú',
          supportTeam: 'Equipo TECOPOS',
        },
        form: {
          type: 'Tipo',
          business: 'Negocio',
          system: 'Sistema',
          title: 'Título',
          description: 'Descripción',
          attachments: 'Adjuntos',
          submit: 'Crear ticket',
          typeIncidencia: 'Incidencia',
          typePropuesta: 'Propuesta',
          requiredField: 'Este campo es obligatorio',
          created: 'Ticket creado',
        },
        scope: {
          checking: 'Verificando tu acceso…',
          deniedTitle: 'Sin acceso a tickets',
          deniedSubtitle:
            'Los tickets de soporte están disponibles para usuarios con una organización o negocios en TECOPOS. Tu usuario aún no tiene ninguno asociado.',
        },
      },
    },
  },
  en: {
    translation: {
      common: {
        loading: 'Loading…',
        error: 'Something went wrong',
        retry: 'Retry',
        cancel: 'Cancel',
      },
      nav: {
        dashboard: 'Dashboard',
        organization: 'My organization',
        businesses: 'My businesses',
        services: 'Services & hardware',
        novedades: "What's new",
        billing: 'Billing',
        credits: 'Credits & top-ups',
        statistics: 'Statistics',
        settings: 'Settings',
        tickets: 'Tickets',
        community: 'Community',
      },
      community: {
        badge: 'TECOPOS Community',
        title: 'Solve your questions with businesses like yours',
        description:
          'The TECOPOS support community is the meeting point between businesses: ask, share solutions and learn from those already using the ecosystem every day.',
        bullet1: 'Questions and answers between businesses, moderated by our team',
        bullet2: 'Verified solutions and recognition for those who help',
        bullet3: 'Open support tickets and follow up without leaving the portal',
        cta: 'Visit the community',
      },
      novedades: {
        badge: "What's new",
        tituloAviso: "What's new in TECOPOS",
        subtituloAviso:
          'A summary of what changed in each product over the last few weeks.',
        verDetalles: 'See the details',
        verTodo: 'See all',
        entendido: 'Got it',
        pieAviso: 'You can read it again in',
        tituloPagina: "What's new",
        subtituloPagina: 'What changed in each product, in two lines.',
        vacio:
          "There's nothing new to report yet. When we ship an improvement, it will show up here.",
        error: "We couldn't load the updates. Please try again in a moment.",
      },
      trivia: {
        seccionMenu: 'Community',
        menu: 'Weekly trivia',
        nuevaPestana: '(opens in a new tab)',
        tarjetaTitulo: 'The weekly community trivia',
        tarjetaTexto:
          'A new question goes live in the community every Monday. Answer it, see if you got it right and earn points.',
        tarjetaCta: 'Go to the trivia',
      },
      releases: {
        badge: 'Updates',
        title: "What's new in your products",
        seeAll: 'See all',
        seeMore: 'See more updates',
        version: 'Version {{version}}',
        historyTitle: 'Product updates',
        historyDescription:
          'Every improvement that reaches production, in plain language: what changed, what got fixed and what you can do now.',
        historyEmpty: 'No release notes published yet.',
        historyEmptyFiltered: 'No release notes for this app yet.',
        allUpdates: 'All updates',
        noteNotFound: "We couldn't find that update. Here are the rest.",
        filterAll: 'All',
        filterAria: 'Filter by app',
        rating: {
          groupAria: 'Rate this update',
          rateAria: 'Rate {{count}} out of 5 stars',
          votes_one: '{{count}} rating',
          votes_other: '{{count}} ratings',
          noVotes: 'No ratings yet',
          yourScore: 'Your rating: {{score}}★',
          signIn: 'Sign in to rate',
          error: "Your rating couldn't be saved. Please try again.",
        },
      },
      tickets: {
        title: 'Support tickets',
        subtitle: 'Support tickets of your organization',
        newTicket: 'New ticket',
        empty: 'No tickets match those filters',
        searchPlaceholder: 'Search by title or code…',
        allStates: 'All states',
        allTypes: 'All types',
        allBusinesses: 'All businesses',
        columns: {
          code: 'Code',
          title: 'Title',
          state: 'State',
          type: 'Type',
          business: 'Business',
          date: 'Date',
        },
        detail: {
          timelineTitle: 'Activity',
          timelineLabel: 'Ticket timeline',
          timelineError: "We couldn't load this ticket's activity",
          opened: 'Ticket opened',
          loadOlder: 'See earlier activity',
          stateChangedFrom: 'Status changed from {{from}} to {{to}} on {{date}}',
          stateChangedTo: 'Status changed to {{to}} on {{date}}',
          attachments: 'Attachments',
          comment: 'Comment',
          commentPlaceholder: 'Write a comment for the support team…',
          confirmFixed: 'Confirm fix',
          confirmFixedQuestion:
            'Do you confirm the fix for this ticket works? The support team will receive your confirmation.',
          fixConfirmed: 'Fix confirmed',
          automatic: 'Automatic',
          you: 'You',
          supportTeam: 'TECOPOS Team',
        },
        form: {
          type: 'Type',
          business: 'Business',
          system: 'System',
          title: 'Title',
          description: 'Description',
          attachments: 'Attachments',
          submit: 'Create ticket',
          typeIncidencia: 'Incident',
          typePropuesta: 'Proposal',
          requiredField: 'This field is required',
          created: 'Ticket created',
        },
        scope: {
          checking: 'Checking your access…',
          deniedTitle: 'No access to tickets',
          deniedSubtitle:
            'Support tickets are available to users with an organization or businesses in TECOPOS. Your user has none associated yet.',
        },
      },
    },
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    // Idioma fijado a español: sin selector de idioma en el portal, la
    // detección por navegador hacía que las vistas con i18n (Comunidad,
    // tickets) salieran en inglés en medio de una UI en español. Las
    // traducciones `en` quedan listas para un futuro selector.
    lng: 'es',
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  })

export default i18n
